import _ from 'lodash'
import { useMemo } from 'react'

import { useApiData } from './useApiData'
import { useCountriesForPreferredProducts } from './useCountriesForPreferredProducts'

export type PreferredProduct = { countryCode?: string; productCode?: string }

export type PreferredProductsResponse = { preferredProducts: PreferredProduct[] }

export const usePreferredProducts = (countryCode?: string, skip?: boolean) => {
  const { countries: allowedCountries, countriesLoading: allowedCountriesLoading } =
    useCountriesForPreferredProducts(skip)

  const {
    data: preferredProductsData,
    loading: preferredProductsLoading,
    refresh: refreshPreferredProducts
  } = useApiData<PreferredProductsResponse>(
    { url: '/api/preferredProducts' },
    { skip, overrideCountryCode: countryCode, skipCountryCode: !countryCode }
  )

  const filteredPreferredProductsData = useMemo(
    () =>
      preferredProductsData && !allowedCountriesLoading
        ? {
            ...preferredProductsData,
            preferredProducts: _.filter(preferredProductsData.preferredProducts, pd =>
              _.some(allowedCountries, ac => ac.code === pd.countryCode)
            )
          }
        : undefined,
    [allowedCountries, allowedCountriesLoading, preferredProductsData]
  )

  return {
    preferredProductsData: filteredPreferredProductsData,
    preferredProductsLoading: preferredProductsLoading || allowedCountriesLoading,
    refreshPreferredProducts
  }
}
